import * as R from "ramda";
import sanitizeHtml from "sanitize-html";
import htmlToDraft from "html-to-draftjs";
import { IChoiceExerciseItem } from "../../components/course-author/types";
import { ICourseComponentPart } from "../../App/Analytics/Common";
import { courseInstructionPartViews } from "../../utils/courseViews";
import { PreferredLocale } from "../../utils/locales";
import { ContentState } from "draft-js";

const getHTML = R.compose(htmlToDraft, sanitizeHtml);

export const htmlToPlainText = (rawHtml: string) => {
  const content = getHTML(rawHtml);
  return ContentState.createFromBlockArray(content.contentBlocks)
    .getPlainText()
    .trim();
};

export function parseAssessmentContent(content: ICourseComponentPart, locale: PreferredLocale) {
  const rawQuestionName = courseInstructionPartViews.exerciseWrapping.localizedTaskBefore(content, locale);
  const questionName = htmlToPlainText(rawQuestionName ?? "");
  const questionType = content.content.singleChoice ? "Single Choice" : "Multi Choice";
  const choices = courseInstructionPartViews.choiceExercisePart.items(content) as IChoiceExerciseItem[];
  return { questionName, questionType, choices };
}
